import { OnlineStorage, IStorageUser } from "@tblabs/storage";
import { Div, RefBool, PopupMenu } from "@tblabs/truffle";
import { Router } from "../Services/Router";
import { AuthButton } from "./AuthButton";
import { UserSectionWhenLoggedIn } from "./UserSectionWhenLoggedIn";


export class UserSection extends Div
{
    constructor(_storage: OnlineStorage, _router: Router)
    {
        super();

        const isUserAuthorized = new RefBool(false);

        _storage.OnUserChange((u: IStorageUser, isAuthorized: boolean) =>
        {
            isUserAuthorized.value = isAuthorized;
        });

        const menu = {
            "🔒 Wyloguj": () => { _storage.Logout(); _router.GoToLogin(); },
            "💰 Wydatki": () => _router.GoToExpenses(),
            "🐔 Agenci": () => _router.GoToAgentsPage()
        };

        const openMenuButton = new UserSectionWhenLoggedIn(_storage)
            .VisibleWhen(isUserAuthorized, v => v == true, "flex");

        this.Append(
            new AuthButton()
                .VisibleWhen(isUserAuthorized, v => v == false),

            new PopupMenu(menu, openMenuButton)
        );
    }
}
